document.addEventListener('DOMContentLoaded', () => {

    const openButton = document.querySelector('.hb-blog__search-button');
    const overlay = document.querySelector('.hb-search-overlay');
    const modal = document.querySelector('.hb-search-modal');
    const closeButton = document.querySelector('.hb-search-close');

    const input = document.querySelector('.hb-search-input');
    const results = document.querySelector('.hb-search-results');

    if (
        !openButton ||
        !overlay ||
        !modal ||
        !closeButton ||
        !input ||
        !results
    ) return;

    let activeIndex = -1;

    function escapeHtml(text) {

        const div = document.createElement('div');

        div.textContent = text || '';

        return div.innerHTML;

    }

    function renderSuggestions() {

        results.innerHTML = `

            <div class="hb-search-empty">

                Začnite tipkati za iskanje člankov...

            </div>

        `;

    }

    function openSearch() {

        overlay.hidden = false;

        document.body.style.overflow = 'hidden';

        input.value = '';

        activeIndex = -1;

        renderSuggestions();

        setTimeout(() => {

            input.focus();

        }, 100);

    }

    function closeSearch() {

        overlay.hidden = true;

        document.body.style.overflow = '';

        input.value = '';

        activeIndex = -1;

    }

    openButton.addEventListener('click', openSearch);

    closeButton.addEventListener('click', closeSearch);

    overlay.addEventListener('click', (e) => {

        if (e.target === overlay) {

            closeSearch();

        }

    });

    document.addEventListener('keydown', (e) => {

        if (e.key === 'Escape') {

            closeSearch();

        }

    });
        function renderResults(matches, query = '') {

        if (!matches.length) {

            results.innerHTML = `

                <div class="hb-search-empty">

                    Ni najdenih člankov.

                </div>

            `;

            return;

        }

        results.innerHTML = '';

        matches.forEach(article => {

            const title = escapeHtml(article.title);

            const excerpt = escapeHtml(article.excerpt);

            const image = article.image
                ? `<img src="${article.image}" alt="${title}">`
                : '';

            results.insertAdjacentHTML('beforeend', `

                <a
                    href="${article.url}"
                    class="hb-search-item">

                    <div class="hb-search-thumb">

                        ${image}

                    </div>

                    <div class="hb-search-content">

                        <h3>

                            ${title}

                        </h3>

                        <p>

                            ${excerpt}

                        </p>

                    </div>

                    <svg
                        class="hb-search-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2">

                        <line
                            x1="5"
                            y1="12"
                            x2="19"
                            y2="12"></line>

                        <polyline
                            points="12 5 19 12 12 19"></polyline>

                    </svg>

                </a>

            `);

        });

    }

    input.addEventListener('input', () => {

        activeIndex = -1;

        const query = input.value.trim().toLowerCase();

        if (!query.length) {

            renderSuggestions();

            return;

        }

        const matches = window.herbessaArticles.filter(article => {

            return (

                article.title.toLowerCase().includes(query)

                ||

                article.excerpt.toLowerCase().includes(query)

            );

        }).slice(0, 8);

        renderResults(matches, query);

    });
        input.addEventListener('keydown', (e) => {

        const items = [...results.querySelectorAll('.hb-search-item')];

        if (!items.length) return;

        if (e.key === 'ArrowDown') {

            e.preventDefault();

            activeIndex++;

            if (activeIndex >= items.length) {

                activeIndex = 0;

            }

            updateActive(items);

        }

        if (e.key === 'ArrowUp') {

            e.preventDefault();

            activeIndex--;

            if (activeIndex < 0) {

                activeIndex = items.length - 1;

            }

            updateActive(items);

        }

        if (e.key === 'Enter') {

            if (activeIndex >= 0) {

                window.location.href = items[activeIndex].href;

            }

        }

    });

    function updateActive(items) {

        items.forEach(item => {

            item.classList.remove('is-active');

        });

        if (activeIndex < 0) return;

        items[activeIndex].classList.add('is-active');

        items[activeIndex].scrollIntoView({

            block: 'nearest'

        });

    }

    document.querySelectorAll('.hb-blog__tag').forEach(tag => {

        tag.addEventListener('click', () => {

            openSearch();

            input.value = tag.textContent.trim();

            input.dispatchEvent(new Event('input'));

        });

    });

    modal.addEventListener('click', (e) => {

        e.stopPropagation();

    });

    renderSuggestions();

});